module.exports = __webpack_public_path__ + "static/work-sans-v7-latin-regular-e11127cd89b44da3216788e512a75dec.woff2";